<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-card
      :style="{
        backgroundColor: coloreSfondo,
        color: coloreTesto,
        borderColor: coloreBordo
      }"
      class="card-panel"
      style="margin-bottom:0px;"
    >
      <b-col md="12">
        <div
          slot="header"
          :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }"
          style="padding-bottom: 10px;"
        >
          <b>{{ uniTranslation("S954") }}</b>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-show="showFull == false">
              <kendo-grid
                :data-source="localWarnings"
                :selectable="'multiple row'"
                :columns="columns"
                :sortable="true"
                :filterable="false"
                :groupable="false"
                :allow-copy="true"
              >
              </kendo-grid>
            </div>
            <div v-show="showFull == true">
              <kendo-grid
                :data-source="localWarnings"
                :selectable="'multiple row'"
                :columns="columnsFull"
                :sortable="true"
                :filterable="false"
                :groupable="false"
                :allow-copy="true"
              >
              </kendo-grid>
            </div>
          </div>
          <!-- <div class="col-xl-6 col-lg-12"> -->
          <!-- :toolbar="['excel']"
                      :excel-file-name="'Warnings.xlsx'"
                      :excel-proxy-URL="'https://demos.telerik.com/kendo-ui/service/export'"
                      :excel-filterable="true" -->
        </div>
        <!-- <div class="row">
            <div class="col-12">
              <el-checkbox v-model="showFull"> Show Full </el-checkbox>
            </div>
          </div> -->
      </b-col>
    </b-card>
  </b-row>
</template>

<script>
// import UnidataEditor from "../unidata/UnidataEditor";
import { mapGetters } from "vuex";
// import { Select, Option, Collapse, CollapseItem, Checkbox } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

import "@progress/kendo-ui";
// import { Grid } from "@progress/kendo-grid-vue-wrapper"; // GridInstaller

export default {
  components: {
    /*UnidataEditor,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem,
    "el-checkbox": Checkbox,
    Grid*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    },
    warnings: {
      required: true
    }
  },
  data() {
    return {
      path: null,
      showFull: false,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreTitolo: "",
      coloreBarraTitolo: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"]),
    localWarnings: function() {
      // alert("localWarnings");

      var that = this;
      var localWarnings = [];
      if (that.warnings !== undefined && that.warnings !== null) {
        that.warnings.forEach(element => {
          let bShow = element.valid && element.showWarning;
          let message = that.uniTranslation(element.message);

          //alert(message);

          let condition = that.uniTranslation(element.condition);
          if (element.variables != null) {
            let i = 0;
            element.variables.forEach(function(variable) {
              condition = condition.split("{" + i + "}").join(variable);
              message = message.split("{" + i + "}").join(variable);
              i += 1;
            });
          }
          if (bShow) {
            localWarnings.push({
              message: message,
              condition: condition,
              variables: JSON.stringify(element.variables),
              phase: element.phase,
              valid: element.valid,
              showWarning: element.showWarning,
              level: that.getLevel(element.level)
            });
          }
        });
      }

      // alert(localWarnings.length);

      return localWarnings;
    },
    columns: function() {
      var that = this;
      return [
        { field: "message", width: "50%", title: that.uniTranslation("S264") },
        { field: "condition", width: "50%", title: that.uniTranslation("S1466") }
      ];
    },
    columnsFull: function() {
      var that = this;
      return [
        { field: "phase", width: "5%", title: "Phase" },
        { field: "valid", width: "10%", title: "Valid" },
        { field: "showWarning", width: "10%", title: "Show" },
        { field: "message", width: "40%", title: that.uniTranslation("S264") },
        { field: "condition", width: "20%", title: that.uniTranslation("S1466") },
        { field: "variables", width: "10%", title: "Variables" },
        { field: "level", width: "5%", title: "Level" }
      ];
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    // var that = this;

    var that = this;
    that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = that.cardColors[1];
    that.coloreTesto = that.cardColors[2];
    that.coloreTitolo = that.cardColors[3];
    that.coloreBordo = that.cardColors[6];
  },
  methods: {
    subViewToggle(subView) {
      this.$store.dispatch(subView);
    },
    getLevel(level) {
      if (level == 1) return "Low";
      if (level == 2) return "Medium";
      if (level == 3) return "High";
    }
  }
};
</script>

<style lang="scss"></style>

<!-- 
/* use it only for testing */
      localDataSource: [{
                "ProductID": 1,
                "ProductName": "Chai",
                "UnitPrice": 18,
                "UnitsInStock": 39,
                "Discontinued": false,
            },
            {
                "ProductID": 2,
                "ProductName": "Chang",
                "UnitPrice": 17,
                "UnitsInStock": 40,
                "Discontinued": false,
            },
            {
                "ProductID": 3,
                "ProductName": "Aniseed Syrup",
                "UnitPrice": 10,
                "UnitsInStock": 13,
                "Discontinued": false,
            }
        ],
-->
